import React from 'react';
import { useDeviceType } from '../../hooks/use-device-type';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Button } from 'components/button';

const contactInfo = [
        {
                icon: <PhoneIcon />,
                label: 'Telefon',
                value: '508 871 292',
                href: 'tel:508871292',
        },
        {
                icon: <EmailIcon />,
                label: 'Email',
                value: 'ameliapalczynska6@gmail.com',
                href: 'mailto:ameliapalczynska6@gmail.com',
        },
        {
                icon: <InstagramIcon />,
                label: 'Instagram',
                value: '@amelia_palczynska',
                href: 'https://www.instagram.com/amelia_palczynska',
        },
        {
                icon: <LocationOnIcon />,
                label: 'Lokalizacja',
                value: 'Studio Sportu Dual, Aleja Wincentego Witosa 11 A, 35-115 Rzeszów',
                href: 'https://www.google.com/maps?q=50.0345579,21.9732359',
        },
];

export default function ContactPage() {
        const deviceType = useDeviceType();

        return (
                <div className="pt-20 lg:pt-24">
                        <section className="py-16 lg:py-24 bg-gradient-to-br from-gray-50 to-white">
                                <div className="max-w-7xl mx-auto px-6">
                                        <div className="text-center mb-16">
                                                <span className="inline-block px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-bold mb-4">
                                                        KONTAKT
                                                </span>
                                                <h1 className="font-playfair-custom-bold text-4xl lg:text-5xl text-gray-900 mb-4">
                                                        Skontaktuj się <span className="text-gradient">ze mną</span>
                                                </h1>
                                                <p className="text-gray-600 font-montserrat-custom-medium max-w-2xl mx-auto">
                                                        Jeśli interesuje Cię współpraca, masz pytania lub chcesz umówić się na konsultację - napisz do mnie!
                                                </p>
                                        </div>

                                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
                                                <div className="order-2 lg:order-1">
                                                        <div className="bg-white rounded-3xl p-8 lg:p-10 shadow-soft-lg">
                                                                <h2 className="font-playfair-custom-bold text-2xl lg:text-3xl text-gray-900 mb-8">
                                                                        Zapisz się na trening
                                                                </h2>

                                                                <p className="text-gray-600 font-montserrat-custom-medium mb-8">
                                                                        Wypełnij formularz zgłoszeniowy, a ja skontaktuję się z Tobą i ustalimy szczegóły współpracy.
                                                                </p>

                                                                <Button
                                                                        variant="tertiary"
                                                                        isLink
                                                                        href="https://tiny.pl/dmdqw"
                                                                        openInNewTab
                                                                        additionalClassName="w-full justify-center text-center"
                                                                >
                                                                        WYPEŁNIJ FORMULARZ ZGŁOSZENIOWY
                                                                </Button>

                                                                <div className="mt-10 pt-10 border-t border-gray-100">
                                                                        <h3 className="font-bold text-gray-900 mb-6">Dane kontaktowe</h3>
                                                                        <div className="space-y-4">
                                                                                {contactInfo.map((item, index) => (
                                                                                        <div key={index} className="flex items-center gap-4">
                                                                                                <div className="w-12 h-12 bg-gradient-to-br from-primary-100 to-primary-200 rounded-xl flex items-center justify-center text-primary-600">
                                                                                                        {item.icon}
                                                                                                </div>
                                                                                                <div>
                                                                                                        <div className="text-gray-500 text-sm font-montserrat-custom-medium">
                                                                                                                {item.label}
                                                                                                        </div>
                                                                                                        {item.href ? (
                                                                                                                <a
                                                                                                                        href={item.href}
                                                                                                                        target={item.href.startsWith('http') ? '_blank' : '_self'}
                                                                                                                        rel="noopener noreferrer"
                                                                                                                        className="text-gray-900 font-bold hover:text-primary-600 transition-colors duration-200"
                                                                                                                >
                                                                                                                        {item.value}
                                                                                                                </a>
                                                                                                        ) : (
                                                                                                                <span className="text-gray-900 font-bold">
                                                                                                                        {item.value}
                                                                                                                </span>
                                                                                                        )}
                                                                                                </div>
                                                                                        </div>
                                                                                ))}
                                                                        </div>
                                                                </div>
                                                        </div>
                                                </div>

                                                <div className="order-1 lg:order-2 relative">
                                                        <div className="relative h-72 lg:absolute lg:inset-0 lg:h-auto rounded-3xl overflow-hidden shadow-soft-lg">
                                                                <img
                                                                        src="/photo_6239.jpg"
                                                                        alt="Amelia Pałczyńska"
                                                                        className="w-full h-full object-cover object-top"
                                                                />
                                                                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-gray-900/85 via-gray-900/40 to-transparent pt-16 pb-8 px-8">
                                                                        <h3 className="font-playfair-custom-bold text-2xl lg:text-3xl text-white mb-1">
                                                                                Amelia Pałczyńska
                                                                        </h3>
                                                                        <p className="text-primary-300 font-bold font-montserrat-custom-medium text-sm tracking-widest uppercase">
                                                                                Trenerka personalna kobiet
                                                                        </p>
                                                                </div>
                                                        </div>
                                                </div>
                                        </div>
                                </div>
                        </section>

                        <section className="py-16 lg:py-24 bg-white">
                                <div className="max-w-6xl mx-auto px-6">
                                        <div className="text-center mb-10">
                                                <h2 className="font-playfair-custom-bold text-3xl lg:text-4xl text-gray-900 mb-4">
                                                        Gdzie możesz mnie <span className="text-gradient">spotkać?</span>
                                                </h2>
                                                <p className="text-gray-600 font-montserrat-custom-medium">
                                                        Prowadzę treningi w <strong>Studio Sportu Dual</strong>, Aleja Wincentego Witosa 11 A, 35-115 Rzeszów
                                                </p>
                                        </div>

                                        <div className="rounded-3xl overflow-hidden shadow-soft-lg">
                                                <iframe
                                                        title="Lokalizacja Studio Sportu Dual Rzeszów"
                                                        src="https://maps.google.com/maps?q=50.0345579,21.9732359&hl=pl&z=17&output=embed"
                                                        width="100%"
                                                        height={deviceType === 'monitor' ? '450' : '300'}
                                                        loading="lazy"
                                                        referrerPolicy="no-referrer-when-downgrade"
                                                        className="border-0"
                                                />
                                        </div>
                                </div>
                        </section>
                </div>
        );
}
